/**
 * Exception type covering authentication and authorization errors.
 **/
export abstract class AuthFailedException extends Error {
  constructor(message) {
    super(message);
    this.message = message;

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, AuthFailedException.prototype);
  }
}
